import { FrequencyType } from '@cbinsights/externalapiservice/externalapiservice';
import { Form, FormInstance, Select } from 'antd';
import { DataFeedFormField } from './DataFeedForm';

export const frequencyCanContinue = (form: FormInstance) =>
  !!form.getFieldValue(DataFeedFormField.frequency);

type SupportedFrequencyType =
  | FrequencyType.FREQUENCY_DAILY
  | FrequencyType.FREQUENCY_MONTHLY
  | FrequencyType.FREQUENCY_WEEKLY;

export const FrequencyOptionLabels: Record<SupportedFrequencyType, string> = {
  [FrequencyType.FREQUENCY_DAILY]: 'Daily',
  [FrequencyType.FREQUENCY_WEEKLY]: 'Weekly',
  [FrequencyType.FREQUENCY_MONTHLY]: 'Monthly',
};

export const isSupportedFrecuencyType = (
  frecuency: FrequencyType
): frecuency is SupportedFrequencyType => frecuency in FrequencyOptionLabels;

export const DataFeedFrequencyTabForm = () => {
  return (
    <Form.Item
      name={DataFeedFormField.frequency}
      label="Select frequency"
      required
    >
      <Select placeholder="Select an option" labelInValue>
        <Select.Option value={FrequencyType.FREQUENCY_DAILY}>
          {FrequencyOptionLabels[FrequencyType.FREQUENCY_DAILY]}
        </Select.Option>
        <Select.Option value={FrequencyType.FREQUENCY_WEEKLY}>
          {FrequencyOptionLabels[FrequencyType.FREQUENCY_WEEKLY]}
        </Select.Option>
        <Select.Option value={FrequencyType.FREQUENCY_MONTHLY}>
          {FrequencyOptionLabels[FrequencyType.FREQUENCY_MONTHLY]}
        </Select.Option>
      </Select>
    </Form.Item>
  );
};
